module.exports = __webpack_public_path__ + "86c2a448909aaacfb5f3bfb7c94ba85c.png";